import store from '../../../store';

export const getIsItemOnTimeline = (timelineItemId) => {
  const timelineLayers = store.getState().videoEditor.video?.data?.config?.timelineLayers;
  return timelineLayers.some((layer) => layer.timeline.includes(timelineItemId));
};
